/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';
import { hasValue } from '@typescript-kit/core';

@Injectable()
export class PersistenceService {
  private _scope: string;

  constructor() { }

  get scope(): string {
    return this._scope;
  }

  set scope(value: string) {
    this._scope = value;
  }

  getValue(key: string, defaultValue?: any, global: boolean = false, type?: string): any {
    if (this.scope && !global) {
      key = `scope:${this.scope}@${key}`;
    }
    const value = localStorage.getItem(key);
    if (value === undefined || value === null) {
      return defaultValue;
    }
    return this.parseValue(value, type || hasValue(defaultValue) ? typeof defaultValue : undefined);
  }

  setValue(key: string, value: any, global: boolean = false, type?: string) {
    const userKey = (this.scope && !global) ? `scope:${this.scope}@${key}` : key;
    const previousValue = this.parseValue(localStorage.getItem(userKey), type || hasValue(type) ? typeof type : undefined);
    if (value === previousValue) {
      return;
    }
    if (value === undefined || value === null) {
      localStorage.removeItem(userKey);
    } else {
      localStorage.setItem(userKey, this.serializeValue(value, type || value && typeof value));
    }
  }

  removeValue(key: string, global: boolean = false) {
    if (this.scope && !global) {
      key = `scope:${this.scope}@${key}`;
    }
    localStorage.removeItem(key);
  }

  private parseValue(value: string, type: string) {
    if (value === undefined || value === null) {
      return value;
    }
    switch (type) {
      case 'boolean':
        const booleanMatch = /^\s*(true|1)|(false|0)\s*$/i.exec(value);
        return booleanMatch ? !!booleanMatch[1] : undefined;
      case 'number':
        return parseFloat(value);
      case 'object':
        return JSON.parse(value);
    }
    return value;
  }

  private serializeValue(value: string, type: string) {
    switch (type) {
      case 'object':
        return JSON.stringify(value);
      default:
        return value.toString();
    }
  }

}
